
// import { create } from 'apisauce'
import axios from 'axios'
/**
 * init class API
 * @param opt
 * @returns {NowakApi}
 * @constructor
 */
function NowakApi (opt) {
  if (!(this instanceof NowakApi)) {
    return new NowakApi(opt)
  }
  opt = opt || {}
  this.classVersion = '1.0.0'
  this.api = axios.create({
    baseURL: opt.url,
    timeout: 9000000
  })
}
// nowakapi.localserver.com
/**
 * Request to the server,
 * You fixed: https://gist.github.com/pranavrajs/66bccee3f8ba100742a1273db6f587af
 * @param url
 * @param callback
 * @returns {axios.Promise}
 * @private
 */
NowakApi.prototype.assignNewOptions = async function (opt) {
  // console.log("New option->", opt);
  this.url = opt
  this.createUpdateApi()
}
NowakApi.prototype.createUpdateApi = async function () {
  // console.log(this.api, 'this.api')
  if (this.api == null) {
    // console.log("creating first time->", this.url);
    this.api = axios.create({
      baseURL: this.url,
      timeout: 20000
      // headers: {'Accept': 'application/vnd.github.v3+json'}
    })
    const naviMonitor = response => {}// console.log("hey!  listen! ", response);
    this.api.addMonitor(naviMonitor)
    // console.log("assigning base url-->", this.url);

    // this.api.addRequestTransform(request => {
    //   request.data.build = buildNumber;
    //   request.data.version = readableVersion;
    // })
  } else {
    this.api.defaults.baseURL = this.url
    console.log('assigning base url->', this.url)
    // this.api.setBaseURL(this.url);
  }
  // console.log("api->", this.api.getBaseURL());
}
NowakApi.prototype._requestAuthPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType
  }
  console.log(headers)
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  })
}
NowakApi.prototype._requestDataPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
NowakApi.prototype._requestDataPostFileAttachment = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType,
    responseType: 'blob'
  }
  return this.api.post(url, data, headers).then((response) => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
NowakApi.prototype._requestDataGet = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  console.log(param)
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
NowakApi.prototype._requestFileDataGet = function (url, contentType, data, callback) {
  var headers = {
    responseType: 'arraybuffer'
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}

NowakApi.prototype.login = async function (data, callback) {
  const requestUrl = 'api/v1/admin/auth/loginToSpecificCompany'
  const contentType = 'application/json'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// employee Api

NowakApi.prototype.EmployeeList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/employeeList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.ReportTolist = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/searchEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.UploadDocToTemp = async function (data, callback) {
  const requestUrl = 'api/v1/admin/tempStorage/uploadFileInTemp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/addEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.RequiredDataForNewEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/requiredListForAddEmp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// department api
NowakApi.prototype.DepartmentList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/departmentList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.BranchDeptlist = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/specificBranchDeptList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.updateDepartmentOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/updateDepartmentOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.DepartmentDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/departmentDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddDepartment = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/addDepartment'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// Branch Api
NowakApi.prototype.BranchList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/branchList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.updateBranchOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/updateBranchOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.BranchDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/branchDetail'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddBranch = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/addBranch'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// Designation Api
NowakApi.prototype.designationList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/designation/designationlist'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddDesignation = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/designation/addDesignation'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.UpdateDesignationOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/designation/updateDesignationOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// employeeTypeList
NowakApi.prototype.employeeTypeList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/employeeType/employeeType'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddemployeeType = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/employeeType/addemployeeType'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.UpdateEmployeeTypeOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/employeeType/updateEmployeeTypeOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// device api
NowakApi.prototype.DeviceListing = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/deviceDetails/deviceListing'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.moduleList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/moduleList '
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.GetEmployeeReportDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/reportToEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.DeviceDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/deviceDetails/deviceInformation'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.getBreakList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/breakDetails/breakList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.getSettingBreakList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/breakDetails/settingBreakList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.updateBreakOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/breakDetails/updateBreakOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.addEditBreak = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/breakDetails/addBreak'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.VerifyContactNumber = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/verifyContactNo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.EmployeeCodeVerification = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/empcodeVerify'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.EmployeeEmailVerification = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/emailVerify'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.EmployeeLoginCodeVerification = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/timeClockloginCodeVerify'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.AddDevice = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/deviceDetails/addDeviceInformation'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// Shift Api
NowakApi.prototype.shiftlist = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/shiftList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Employee detail api start here
NowakApi.prototype.EmaployeeBasicDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/employeeBasicDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.EmaployeeBranchDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/branchDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// bank detail

NowakApi.prototype.loadEmployeeBankDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/bankDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// experience detail

NowakApi.prototype.loadEmployeeExperienceDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/workExperienceDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// educational detail
NowakApi.prototype.loadEmpEducationalDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/educationDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// salary detail
NowakApi.prototype.loadEmployeeSalaryDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/salaryDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// EMP Device detail

NowakApi.prototype.LoadEmpDeviceDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/deviceDetailsInfo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// document detail
NowakApi.prototype.loadDocumentDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/documentDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// add document
NowakApi.prototype.UploadDocToTemp = async function (data, callback) {
  const requestUrl = 'api/v1/admin/tempStorage/uploadFileInTemp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// ------------------------update details-------------------------------------------
// update basic details
NowakApi.prototype.saveEmployeeBasicDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateBasicDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update personal details

NowakApi.prototype.savePersonalDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updatePersonalDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update personal details

NowakApi.prototype.updateDeviceDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateDeviceInfo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update emergency details
NowakApi.prototype.saveEmergencyDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateEmergencyDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update additonal info

NowakApi.prototype.saveAditionalDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateAdditionalDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update branch Detail

NowakApi.prototype.saveBranchDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateBranchDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update salary Detail

NowakApi.prototype.saveSalaryDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateSalaryDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update bank details

NowakApi.prototype.saveBankDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateBankDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update education details

NowakApi.prototype.saveEducationDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateEducationalDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update work exp details

NowakApi.prototype.saveExperienceDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateWorkDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update Doc
NowakApi.prototype.AddDocumentDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/addDocument'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// display login details

NowakApi.prototype.loadLoginDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/loginDetailsEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update profile details
NowakApi.prototype.UpdateProfile = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateProfileDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update emergency details
NowakApi.prototype.saveEmergencyDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateEmergencyDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update additonal info

NowakApi.prototype.saveAditionalDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateAdditionalDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update branch Detail

NowakApi.prototype.saveBranchDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateBranchDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update salary Detail

NowakApi.prototype.saveSalaryDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateSalaryDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update bank details

NowakApi.prototype.saveBankDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateBankDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update education details

NowakApi.prototype.saveEducationDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateEducationalDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update work exp details

NowakApi.prototype.saveExperienceDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateWorkDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// display login details

NowakApi.prototype.loadLoginDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/loginDetailsEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// update login details

NowakApi.prototype.saveLoginDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateLoginDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// Shift settings
NowakApi.prototype.ADDShift = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/addshift'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateShiftOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/updateshiftOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.ADDNote = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/addNote'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// delete document

NowakApi.prototype.deleteDocument = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/deleteDocument'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// delete from tempt storage
NowakApi.prototype.deleteDocumentFromTemp = async function (data, callback) {
  const requestUrl = 'api/v1/admin/tempStorage/deleteFileFromTemp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.DeleteMultipleFileFromTemp = async function (data, callback) {
  const requestUrl = 'api/v1/admin/tempStorage/deleteMultipleFile'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.downloadFile = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/downLoadDocument'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPostFileAttachment(requestUrl, contentType, data, callback)
}

NowakApi.prototype.downloadNoteAttachments = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/downloadNoteAttachment'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPostFileAttachment(requestUrl, contentType, data, callback)
}

NowakApi.prototype.getLocation = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/downloadNoteAttachment'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.GetFilterRelatedAllData = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/getFilterRealtedAllData'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.SearchForMoreDataOfEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/searchForDataOfEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// ******Leave settings api ***********//
NowakApi.prototype.AddleaveReason = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/addLeaveReason'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetLeaveReasonList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/leavereasonlist'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateLeaveReasonOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateReasonOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
//* *****Leave Status API */
NowakApi.prototype.UpdateLeaveStatusOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateStatusOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetLeaveStatusList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/leavestatuslist'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateLeaveStatusColor = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateStatus'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// **************LEAVE API***********************
NowakApi.prototype.GetLeaveList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/leaveList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddNewLeave = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/addLeave'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForLeaveOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/checkForOverlapLeave'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetLeaveDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/leaveDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateEmployeeLeaveStatus = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/updateLeaveDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// ******Leave settings api ***********//
NowakApi.prototype.AddleaveReason = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/addLeaveReason'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetLeaveReasonList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/leavereasonlist'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateLeaveReasonOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateReasonOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
//* *****Leave Status API */
NowakApi.prototype.UpdateLeaveStatusOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateStatusOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetLeaveStatusList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/leavestatuslist'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateLeaveStatusColor = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/leave/updateStatus'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// *******************TIMESHEET API START HERE*****************************/
NowakApi.prototype.GetTimesheetLocation = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/timeSheetLocation'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.GetOpenShiftList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/openShiftList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetCompletedShiftList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/getCompletedShiftDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetAllShiftList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/allShiftList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetEmployeeNotClockedInYet = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/getEmployeeNotClockedInYet'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.ShiftDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/timesheetDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.Notesdetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/timeSheetNotesWithAttach'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.DownloadDocs = async function (data, callback) {
  const requestUrl = 'api/v1/admin/tempStorage/uploadFileInTemp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// TIMESHEET UPDATE
NowakApi.prototype.UpdateTimesheet = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/updateTimesheet'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckTimesheetOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/checkOverlapTimesheet'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForBreakOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/checkForBreakOverlap'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateTimesheetBreakDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/updateTimesheetBreakDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

// MISSING SHIFT
NowakApi.prototype.CheckForOverLapTimesheet = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/missingShifts/checkForPresentTimesheet'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddMissingShift = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/missingShifts/addMissingShift'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetShiftDetailsOfEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/shiftDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetNotificationForDevice = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/notification/getDeviceNotificationDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AcceptDeviceNotification = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/notification/approveAddDeviceNotification'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.GetLogedInEmployeePermissions = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/getLogedinEmployeePermissions'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetPermissionForMenuAndSubMenu = async function (data, callback) {
  const requestUrl = 'api/v1/admin/permissions/getPermissionForMenu'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Role Permissions
NowakApi.prototype.GetRoleDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/role/getRolePermissionDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetCompanyRoleList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/role/getRoleList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddNewCompanyRole = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/role/addNewRole'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateRoleOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/role/updateRoleOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetEmployeePermissions = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/getEmployeePermissions'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateEmployeePermissions = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/updateEmployeePermissions'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetMaxAndMinBReakDates = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/getMaxAndMinBreakDates'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetTimesheetDetailsOfLoggedInEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/timeSheet/getTimesheetDetailsOfLoggedInEmployee'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.GetListOfBranchAndEmployeeInShift = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/getListOfBranchAndEmployeeInShift'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForDeviceOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/deviceDetails/checkForOverlapDevice'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// ******************HOLIDAY Api Start here ***********************
NowakApi.prototype.GetHolidayList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/holidayList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetHolidayDetailsList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/holidayDetailsList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddNewHolidayList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/addholidayDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddNewHoliday = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/addHoliday'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateHolidayDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/updateholidayDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.DeleteHolidayDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/deleteholiday'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForHolidayOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/checkForHolidayOverlap'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}

NowakApi.prototype.UpdateHolidayListDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/updateHolidayList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetMaxAndMixHolidays = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/getMaxAndMix'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForHolidayListOverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/checkHolidayList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// CATEGORY API
NowakApi.prototype.GetCategoryList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/category/categoryList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddCategory = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/category/addCategory'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateCategoryOrder = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/category/updateCategoryOrder'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.ChangeEmployeeAndBranchShiftId = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/changeEmployeeAndBranchShiftId'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.CheckForShiftStartAndEndTimeoverlap = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/shifts/checkForOverlapShift'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddNewHolidays = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/addHolidaysInList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// SETTINGS
NowakApi.prototype.GetBranchRelatedDeptAndEmp = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/getBranchRelatedDeptAndEmp'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetBranchAndDepartmentList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/getBranchAndDepartmentList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.UpdateBranchDepartmentDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/branch/updateBranchDepartmentDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetDepartmentRelatedData = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/getDepartmentRelatedData'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.ChangeDepartmentRelatedData = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/department/changeDepartmentRelatedData'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.AddDeviceFromLogin = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/settings/deviceDetails/addNewDeviceFromLogin'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetEmployeeListForSelectedModule = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/getEmployeeListForSelectedModule'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
// Activity Log APi
NowakApi.prototype.GetActivityLogForGivenModule = async function (data, callback) {
  const requestUrl = 'api/v1/admin/activity/getActivityLogForGivenModule'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetRequiredDataForActivityLog = async function (data, callback) {
  const requestUrl = 'api/v1/admin/activity/getRequiredDataForActivityLog'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
/** **********************NOTES************************/
NowakApi.prototype.AddNewNotes = async function (data, callback) {
  const requestUrl = 'api/v1/admin/notes/addNotes'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.ApproveDevice = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/notification/approveAddDeviceNotification'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetNotesDetails = async function (data, callback) {
  const requestUrl = 'api/v1/admin/notes/getNotesDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.DownloadNotes = async function (data, callback) {
  const requestUrl = 'api/v1/admin/notes/downloadNotes'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPostFileAttachment(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetActivityLogDetail = async function (data, callback) {
  const requestUrl = 'api/v1/admin/activity/getActivtiyLogDetails'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.GetModuleListForEmployee = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/employee/getModuleList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.upcomingHolidayListForDashboard = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/holidays/upcomingHolidayList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.getTodayLeavelist = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/getTodaysLeaveList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
NowakApi.prototype.getUpcomingLeaveList = async function (data, callback) {
  const requestUrl = 'api/v1/admin/hrm/leave/upcomingLeaveList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
export default NowakApi



// WEBPACK FOOTER //
// ./src/api/NowakApi.js